import controller from './autoRefreshCheck.controller';
import template from './autoRefreshCheck.html';

const autoRefreshCheckComponent = {
  restrict: 'E',
  bindings: {
    termini: '<',
    onClose: '&'
  },
  template,
  controller
};

export default autoRefreshCheckComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/autoRefreshCheck/autoRefreshCheck.component.js
 **/